<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Статус договора</h1>
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item user-list__search page__search">
            <SearchForm :value="searchValue"
                        @form-submit="setSearchValue"
            />
          </div>
        </div>
        <div class="page__item">
          <div class="page__row">
            <transition name="fade" v-if="roleAccessRemove">
              <div class="page__item" v-if="isActiveDelete">
                <AppButtonSmRemove title="Удалить" @click.stop.native="showRemoveConfirmationGroup" />
              </div>
            </transition>
            <div class="page__item" v-if="roleAccessCreate">
              <AppButtonSmAdd title="Создать"
                              @click.native="showModal(null)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="page__row mb-20" v-if="statuses.length !== 0">
        <AppTable :data="statuses"
                  :headers="tableHeader"
                  :has-checkbox="roleAccessRemove"
                  :isMenuControlsActive=false
                  :all-items-active="tableHeader.allActive"
                  @toggle-active-item="toggleActiveItem"
                  @toggle-active-all="toggleActiveAll"
                  @edit-this-item="showModal"
                  @show-this-item="showModal"
                  @save-item-info="saveContractStatusItem"
        />
      </div>
      <div class="page__row mb-20"  v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Записи не найдены"/>
        </div>
      </div>
    </section>

    <section class="section page__footer user-list__footer">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade">
      <AppConfirmation  v-if="removeConfirmation.active && roleAccessRemove"
                        :text="removeConfirmation.group ? 'Вы действительно хотите удалить эти статусы?' : 'Вы действительно хотите удалить этот статус?'"
                        @confirm="removeConfirmation.group ? deleteContractsStatusChecked() : removeStatus()"
                        @reject="closeRemoveConfirmation"
      />
      <ContractStatusModal v-if="modal.active && roleAccessEdit"
                          :state="modal"
                          @set-item-name="setContractStatusItemName"
                          @clear-validation="clearModalValidation"
                          @save-item-info="saveContractStatusItem"
                          @close-modal="closeModal"
      />
      <AppModal v-if="deleteResponseModal.isActive && !deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModal.title"
                :text="deleteResponseModal.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModal.type"
                @confirm="closeDeleteModal"
      />
      <AppModal v-if="deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModalWithTreaties.title"
                :text="deleteResponseModalWithTreaties.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModalWithTreaties.type"
                @confirm="closeDeleteModalWithTreaties"
      />
    </transition>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>

import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import ContractStatusModal from '@/components/contract/ContractStatusModal'
import AppModal from '@/components/page/modal/AppModal'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import VPagination from '@/components/page/VPagination'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractStatus',
  components: {
    ThePagePreloader,
    AppConfirmation,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    SearchForm,
    ContractStatusModal,
    AppModal,
    AppButtonSmRemove,
    VPagination
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      }
    }
  },
  computed: {
    ...mapGetters('contractStatusListPage', [
      'getContractsStatusListModal',
      'getContractsStatusListTableHeaders',
      'getContractsStatusList',
      'getContractsStatusListSearchValue',
      'getContractsStatusListFilter',
      'getContractsStatusListPagination',
      'contractStatusListIsLoading',
      'getContractsStatusListResponseModal',
      'getContractsStatusListResponseModalWithTreaties',
      'getContractsStatusListActiveDelete'
    ]),

    modal () {
      return this.getContractsStatusListModal
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    tableHeader () {
      return this.getContractsStatusListTableHeaders
    },
    statuses () {
      return this.getContractsStatusList.map(status => {
        return ({
          id: status.id,
          isActive: status.isActive,
          values: [
            status.name
          ]
        })
      })
    },
    searchValue () {
      return this.getContractsStatusListSearchValue
    },
    filter () {
      return this.getContractsStatusListFilter
    },
    pagination () {
      return this.getContractsStatusListPagination
    },
    isLoading () {
      return this.getContractStatusListIsLoading
    },
    deleteResponseModal () {
      return this.getContractsStatusListResponseModal
    },
    deleteResponseModalWithTreaties () {
      return this.getContractsStatusListResponseModalWithTreaties
    },
    isActiveDelete () {
      return this.getContractsStatusListActiveDelete
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightContracts.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContracts.actions.remove
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightContracts.actions.update
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch('contractStatusListPage/toggleContractsStatusListItemControls', itemId)
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('contractStatusListPage/toggleContractsStatusListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('contractStatusListPage/toggleContractsStatusListItemActiveAll')
    },
    showModal (itemId) {
      this.$store.dispatch('contractStatusListPage/showContractsStatusModal', itemId)
    },
    setContractStatusItemName (value) {
      this.$store.dispatch('contractStatusListPage/setContractsStatusItemName', value)
    },
    clearModalValidation (inputName) {
      this.$store.dispatch('contractStatusListPage/clearContractsStatusModalValidation', inputName)
    },
    saveContractStatusItem () {
      this.$store.dispatch('contractStatusListPage/saveContractsStatusItem')
    },
    closeModal () {
      this.$store.dispatch('contractStatusListPage/closeContractsStatusModal')
    },
    showRemoveConfirmation (id) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
    },
    removeStatus () {
      const itemId = this.removeConfirmation.id
      this.$store.dispatch('contractStatusListPage/removeContractsStatus', itemId)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    deleteContractsStatusChecked () {
      this.removeConfirmation.active = false
      this.$store.dispatch('contractStatusListPage/deleteContractsStatusListCheckedItems')
      this.removeConfirmation.group = false
    },
    closeDeleteModal () {
      this.$store.dispatch('contractStatusListPage/closeContractsStatusListDeleteModal')
    },
    closeDeleteModalWithTreaties () {
      this.$store.dispatch('contractStatusListPage/closeContractsStatusListDeleteModalWithTreaties')
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('contractStatusListPage/setContractsStatusListSearchValue', value)
    },

    // filter

    // pagination
    getPage (pageNum) {
      this.$store.dispatch('contractStatusListPage/getContractsStatusListPage', pageNum)
    }
  },
  mounted () {
    this.$store.dispatch('contractStatusListPage/getContractsStatus')
  },

  destroyed () {
    this.$store.commit('contractStatusListPage/RESET_CONTRACTS_STATUS_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}
</style>
